export default "__VITE_ASSET__DPBQ1x0P__"